import { makeStyles } from "tss-react/mui"
import { Box, MenuItem, TextField } from "@mui/material"
import { CreateMobileAVResourceForm, RoomDetailsColor } from "../../../resourcesTypes"
import { StandardForm } from "../../../../../../../../shared/components/forms/StandardForm"
import { StandardMainPanel } from "../../../../../../../../shared/components/forms/StandardMainPanel"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../../localization/components/AppLocalized"
import {
    FormikAutoComplete,
    FormikDropdown,
    FormikSwitch,
    FormikTextField,
} from "../../../../../../../../shared/components/forms/Formik"
import { StandardSidePanel } from "../../../../../../../../shared/components/forms/StandardSidePanel"
import { FormikImageUpload } from "../../../../../../../../shared/components/Formik/FormikImageUpload"
import { useFormikContext } from "formik"

const useStyles = makeStyles()(() => ({
    fieldWidth: {
        width: "50%",
    },
}))

const cleanupBufferOptions = Array.from({ length: 12 }, (_, index) => index * 5)

export function FormMobileAVGeneralContent() {
    const { classes } = useStyles()
    const { values } = useFormikContext<CreateMobileAVResourceForm>()

    return (
        <StandardForm>
            <StandardMainPanel>
                <LocalizedStrict
                    id="resources-create-mobile-av-tab-general-serial-number-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField name="avDetails.serialNumber" label="Serial number" />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-mobile-av-tab-general-name-label" attrs={{ label: true }}>
                    <FormikTextField name="name" label="Name" />
                </LocalizedStrict>
                <LocalizedStrict id="resources-create-mobile-av-tab-general-description-label" attrs={{ label: true }}>
                    <FormikTextField rows={4} multiline name="description" label="Description" />
                </LocalizedStrict>
                <LocalizedStrict id="merchant-menu-planning-dialog-upload-image" attrs={{ label: true }}>
                    <FormikImageUpload label="Upload image" name="image.uid" typeOfEntity="resource" />
                </LocalizedStrict>
                <LocalizedStrict
                    id="resources-create-mobile-av-tab-general-storage-location-label"
                    attrs={{ label: true }}
                >
                    <FormikTextField name="avDetails.storageLocation" label="Storage location" />
                </LocalizedStrict>
                <Box className={classes.fieldWidth}>
                    <LocalizedStrict
                        id="resources-create-mobile-av-tab-general-color-code-label"
                        attrs={{ label: true }}
                    >
                        <FormikDropdown fullWidth name="color" label="Color code">
                            {Object.values(RoomDetailsColor).map((color) => (
                                <MenuItem key={color} value={color}>
                                    <LocalizedEnum base="resources-create-room-tab-general-color" enumValue={color}>
                                        <span>{color}</span>
                                    </LocalizedEnum>
                                </MenuItem>
                            ))}
                        </FormikDropdown>
                    </LocalizedStrict>
                </Box>

                <Box className={classes.fieldWidth}>
                    <LocalizedStrict id="resources-create-mobile-av-tab-general-floor-label" attrs={{ label: true }}>
                        <FormikTextField fullWidth name="avDetails.floor" label="Floor" type="number" />
                    </LocalizedStrict>
                </Box>
                <Box className={classes.fieldWidth}>
                    <LocalizedStrict
                        id="resources-create-mobile-av-tab-general-cleanup-buffer-label"
                        attrs={{ label: true }}
                    >
                        <FormikDropdown fullWidth name="buffer" label="Cleanup buffer">
                            {cleanupBufferOptions.map((value) => (
                                <MenuItem key={value} value={value}>
                                    {value}
                                </MenuItem>
                            ))}
                        </FormikDropdown>
                    </LocalizedStrict>
                </Box>
                <LocalizedStrict id="resources-create-room-tab-general-tags-label" attrs={{ label: true }}>
                    <FormikAutoComplete
                        name="tags"
                        label="Tags"
                        freeSolo
                        multiple
                        options={values.tags ?? []}
                        fullWidth
                        renderInput={() => <TextField />}
                    />
                </LocalizedStrict>
            </StandardMainPanel>
            <LocalizedStrict id="resources-create-mobile-av-tab-general-side-settings" attrs={{ title: true }}>
                <StandardSidePanel variant="collapsible" title="Settings">
                    <LocalizedStrict id="resources-create-mobile-av-tab-general-active-label">
                        <FormikSwitch<CreateMobileAVResourceForm> name="isActive">Active:</FormikSwitch>
                    </LocalizedStrict>
                </StandardSidePanel>
            </LocalizedStrict>
        </StandardForm>
    )
}
